import * as React from "react";
import { useEffect } from "react";
import useProductName from "brand-customization/useProductName";
const DocumentTitle = ({ children, title }) => {
  const productName = useProductName();
  useEffect(() => {
    document.title = `${document.title} - ${title}`;
    return () => {
      document.title = productName;
    };
  }, [productName, title]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export default DocumentTitle;
